import {

    RESET_REVIEWING_REPORT,

    VIEW_WORKLIST_VISIT_SUCCESS,
    VIEW_WORKLIST_VISIT_ERROR,
    VIEW_WORKLIST_VISIT_START,

    VIEW_PARKED_VISIT_START,
    VIEW_PARKED_VISIT_SUCCESS,

    VIEW_REVIEW_PENDING_REPORT_START,
    VIEW_REVIEW_PENDING_REPORT_ERROR,

    VIEW_SUBMITTED_TO_TYPIST_VISIT_START,
    VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR,

    VIEW_HISTORY_REPORT_START,
    VIEW_HISTORY_REPORT_ERROR,
    VIEW_HISTORY_REPORT_SUCCESS,

    UPDATE_REVIEWING_REPORT_STATUS_START,
    UPDATE_REVIEWING_REPORT_STATUS_SUCCESS,
    UPDATE_REVIEWING_REPORT_STATUS_ERROR,

    // SEARCH_AND_VIEW_REVIEW_PENDING_REPORT_START,
    // SEARCH_AND_VIEW_REVIEW_PENDING_REPORT_SUCCESS,
    // SEARCH_AND_VIEW_REVIEW_PENDING_REPORT_ERROR,

    FETCH_PATIENT_HISTORY_REPORTS_START,
    FETCH_PATIENT_HISTORY_REPORTS_ERROR,
    FETCH_PATIENT_HISTORY_REPORTS_SUCCESS,

    UNLOCK_VISIT_START,
    UPDATE_TICKET_ID,

    SAVE_VISIT_REPORT_DICTATION_SUCCESS,
    SUBMIT_VISIT_REPORT_DICTATION_SUCCESS,

    VIEW_VERIFIED_VISIT_SUCCESS,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS,
    UPDATE_VISIT_REPORT_STATE_SUCCESS,
    UPDATE_VISIT_REPORT_STATE_START,
    UPDATE_VISIT_REPORT_STATE_ERROR,
    VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR,
    UPDATE_STUDY_SUCCESS,
    ADD_REPORT_DIAGRAM_SUCCESS

} from '../../actions/mrt/reportViewerAction';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    searchParams: null,
    found: false,
    report: null,
    unlocking: false,
    priorReportsLoaded: false,
    patientHistoryReports: []
};

const reportViewerReducer = (state = INIT_STATE, action) => {
    let newState;
    let newReport;
    let index;
    switch (action.type) {
        case VIEW_WORKLIST_VISIT_START:
        case VIEW_REVIEW_PENDING_REPORT_START:
        case VIEW_SUBMITTED_TO_TYPIST_VISIT_START:
        case VIEW_HISTORY_REPORT_START:
        case VIEW_PARKED_VISIT_START: {
            return { ...state, error: '', message: '', found: false, loading: true };
        }
        case VIEW_WORKLIST_VISIT_SUCCESS:
        case VIEW_HISTORY_REPORT_SUCCESS:
        case VIEW_VERIFIED_VISIT_SUCCESS:
        case VIEW_PARKED_VISIT_SUCCESS:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS: {
            return { ...state, error: '', message: '', found: true, loading: false, report: { ...action.report } };
        }
        case VIEW_WORKLIST_VISIT_ERROR:
        case VIEW_REVIEW_PENDING_REPORT_ERROR:
        case VIEW_SUBMITTED_TO_TYPIST_VISIT_ERROR:
        case VIEW_HISTORY_REPORT_ERROR:
        case VIEW_SUBMITTED_FOR_VERIFICATION_VISIT_ERROR:
        case FETCH_PATIENT_HISTORY_REPORTS_ERROR: {
            return { ...state, error: '', message: '', found: false, loading: false };
        }
        case FETCH_PATIENT_HISTORY_REPORTS_SUCCESS: {
            return { ...state, error: '', message: '', patientHistoryReports: action.patientHistoryReports, priorReportsLoaded: true };
        }


        case UPDATE_REVIEWING_REPORT_STATUS_START: {
            return { ...state, error: '', message: '', submitting: true };
        }
        case UPDATE_REVIEWING_REPORT_STATUS_SUCCESS: {
            return { ...state, error: '', message: '', submitting: false, report: { ...action.report } };
        }
        case UPDATE_REVIEWING_REPORT_STATUS_ERROR: {
            return { ...state, error: '', message: '', submitting: false };
        }
        case RESET_REVIEWING_REPORT: {
            return { ...INIT_STATE };
        }
        case UNLOCK_VISIT_START: {
            return { ...state, unlocking: true };
        }
        case UPDATE_TICKET_ID: {
            newState = { ...state };
            if (action.ticket.reportId === newState.report.visit.reportId) {
                let report = { ...newState.report };
                report.visit = { ...report.visit, ticketId: action.ticket.ticketId };
                return { ...state, report };
            }
            return newState;
        }

        case SAVE_VISIT_REPORT_DICTATION_SUCCESS: {
            newState = { ...state, report: { ...action.report } };
            return newState;
        }

        case SUBMIT_VISIT_REPORT_DICTATION_SUCCESS: {
            newState = { ...state, report: { ...action.report } };
            return newState;
        }

        case UPDATE_VISIT_REPORT_STATE_START: {
            return { ...state, error: '', message: '', submitting: true };
        }

        case UPDATE_VISIT_REPORT_STATE_SUCCESS: {
            newReport = { ...state.report };
            newReport.visit = { ...action.visit };
            return {
                ...state,
                error: '',
                message: '',
                submitting: false,
                report: {
                    ...newReport
                }
            };
        }

        case UPDATE_VISIT_REPORT_STATE_ERROR: {
            return { ...state, error: '', message: '', submitting: false };
        }

        case UPDATE_STUDY_SUCCESS: {
            newState = _.cloneDeep(state);
            newState.report.visit = { ...state.report.visit, priority: action.visit.priority }
            return { ...newState }
        }

        case ADD_REPORT_DIAGRAM_SUCCESS: {
            let modifiedDiagrams = [...(state.report.diagrams || [])];
            modifiedDiagrams.push(action.diagram);
            return {
                ...state,
                report: {
                    ...state.report,
                    diagrams: [...modifiedDiagrams]
                }
            };
        }

        default:
            return state;
    }
}

export default reportViewerReducer;
